import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'

export default function QrCodeDialog({
    openDialogQr,
    setOpenDialogQr,
    qrCode
}) {
  return (
    <Dialog open={openDialogQr} onClose={() => setOpenDialogQr(false)}>
        <DialogTitle>Qr Code</DialogTitle>
        <DialogContent>
          <img src={`data:image/jpeg;base64,${qrCode}`} alt="QR Code" />
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpenDialogQr(false)} >ปิด</Button>
        </DialogActions>
    </Dialog>
  )
}
